import Modal from '@/components/ui/modal';
import { useTranslations } from 'next-intl';
import React from 'react';

interface OtherLanguageModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export default function OtherLanguageModal({ isOpen, onClose }: OtherLanguageModalProps) {
    const t = useTranslations();

    const textClassName: string = 'font-normal text-[18px] text-shadow-[0_4px_4px_rgb(0_0_0_/_0.25)]';

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            ModalSize="max-w-[580px] w-full"
            closePosition="right-[40px] top-[20px]"
            modalPadding="pt-[38px] pb-[39px] px-[34px]"
            rounded="rounded-[8px]"
        >
            <div className="flex flex-col items-center">
                <h3 className="text-center font-bold mt-3 text-[24px] mb-[10px]">
                    {t('ScreeningRoom.modal.otherLanguage.title')}
                </h3>
                <div className="text-lg text-center">
                    <p className={textClassName}>{t('ScreeningRoom.modal.otherLanguage.subTitle')}</p>
                    <p className="text-[#DD06AE] my-5 font-bold text-xl text-[20px]">
                        {t('ScreeningRoom.modal.otherLanguage.strong')}
                    </p>
                    <p className={`my-5 ${textClassName}`}>{t('ScreeningRoom.modal.otherLanguage.info1')}</p>
                    <p className={textClassName}>{t('ScreeningRoom.modal.otherLanguage.info2')}</p>
                </div>
            </div>
        </Modal>
    );
}
